import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { countries, devConfig, gamesCasino, profile, providersCasino } from 'config/config';

/**
 * Class representing the view for partner products table.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from URL parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template for the rating column
                                        if (devConfig.getPermAction('partnersProductsEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon
                                        } else {
                                            return '';
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: _('Id'), // Localized header
                                    width: 50,
                                    sort: 'int', // Sort type
                                },
                                {
                                    id: 'Product',
                                    header: _('Producto'), // Localized header
                                    width: 200,
                                    sort: 'int',
                                },
                                {
                                    id: 'Image',
                                    header: _('Imagen'), // Localized header
                                    width: 570,
                                    sort: 'int',
                                },
                                {
                                    id: 'Image2',
                                    header: _('Imagen cuadrada'), // Localized header
                                    width: 570,
                                    sort: 'int',
                                },
                                {
                                    id: 'ProviderId',
                                    header: _('Proveedor'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Partner',
                                    header: _('Partner'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'IsActivate',
                                    header: _('Estado'), // Localized header
                                    editor: 'combo', // Editor type
                                    options: [
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 80,
                                    sort: 'int',
                                },
                                {
                                    id: 'IsVerified',
                                    header: _('Verificado'), // Localized header
                                    editor: 'combo', // Editor type
                                    options: [
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 90,
                                    sort: 'int',
                                },
                                {
                                    id: 'FilterCountry',
                                    header: _('Filtro País'), // Localized header
                                    editor: 'combo', // Editor type
                                    options: [
                                        { id: 'A', value: _('Activado') }, // Active option
                                        { id: 'I', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Mobile',
                                    header: _('Mobile'), // Localized header
                                    editor: 'combo', // Editor type
                                    options: [
                                        { id: 'S', value: _('Activado') }, // Active option
                                        { id: 'N', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 90,
                                    sort: 'int',
                                },
                                {
                                    id: 'Desktop',
                                    header: _('Escritorio'), // Localized header
                                    editor: 'combo', // Editor type
                                    options: [
                                        { id: 'S', value: _('Activado') }, // Active option
                                        { id: 'N', value: _('Inactivado') }, // Inactive option
                                    ],
                                    width: 90,
                                    sort: 'int',
                                },
                                {
                                    id: 'Maximum',
                                    header: _('Máximo'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Minimum',
                                    header: _('Mínimo'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'ProcessingTime',
                                    header: _('Tiempo Procesamiento'), // Localized header
                                    width: 180,
                                    sort: 'int',
                                },
                                {
                                    id: 'Order',
                                    header: _('Orden'), // Localized header
                                    width: 180,
                                    sort: 'int',
                                },
                                {
                                    id: 'FeaturedOrder',
                                    header: _('Orden Destacado'), // Localized header
                                    width: 180,
                                    sort: 'int',
                                },
                                {
                                    id: 'Rows',
                                    header: _('Filas'), // Localized header
                                    width: 180,
                                    sort: 'int',
                                },
                                {
                                    id: 'Columns',
                                    header: _('Columnas'), // Localized header
                                    width: 180,
                                    sort: 'int',
                                },
                                {
                                    id: 'CodeMincetur',
                                    header: _('Codigo MINCETUR'), // Localized header
                                    width: 180,
                                    sort: 'int',
                                },
                            ],
                            onClick: {
                                edit: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$('editwinPartnerProducts').show(); // Show the edit window
                                    if (item['TypeProduct'] == 'PAYMENT') {
                                        // Check product type
                                        $$('ImageURL').define(
                                            'value',
                                            'Imagen Izquierda', // Set label for left image
                                        );
                                        $$('ImageURL2').define(
                                            'value',
                                            'Imagen Derecha', // Set label for right image
                                        );
                                        $$('ImageURL').refresh(); // Refresh the component
                                        $$('ImageURL2').refresh(); // Refresh the component
                                    } else {
                                        $$('ImageURL').define(
                                            'value',
                                            'Imagen rectangular', // Set label for rectangular image
                                        );
                                        $$('ImageURL2').define(
                                            'value',
                                            'Imagen cuadrada', // Set label for square image
                                        );
                                        $$('ImageURL').refresh(); // Refresh the component
                                        $$('ImageURL2').refresh(); // Refresh the component
                                    }
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            url:
                                devConfig.geturlApi() +
                                'PartnersProducts/GetPartnersProducts?Partner=' +
                                id_partner +
                                '&', // Data source URL
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._;
        grid = $$('datatable'); // Reference to the datatable
        var url = grid.data.url; // Store the URL for data loading
        var products = []; // Array to hold product data
        var filter = ''; // Filter string for data loading
        var optionsCategorias = []; // Array for category options
        var vthis = this; // Reference to the current instance
        var popup = ''; // Variable for the edit popup
        var popupAdd = ''; // Variable for the add popup
        var arrayPartnersAdd = []; // Array for partners to add
        var arrayPartnersWithoutAdd = []; // Array for partners without add
        var arrayPartnersEdit = []; // Array for partners to edit
        var arrayPartnersWithoutEdit = []; // Array for partners without edit
        var arrayAdd = []; // Array for add operations
        var arrayWithoutAdd = []; // Array for operations without add
        var arrayAddEdit = []; // Array for edit operations
        var arrayWithoutAddEdit = []; // Array for operations without edit
        const id_partner = this.getParam('partner', true); // Get partner ID from URL parameters

        // Fetch categories from the API
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Categories/GetCategories', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parse the response
                    for (var i = 0; i < resp.data.length; i++) {
                        resp.data[i].id = resp.data[i].Id; // Map ID
                        resp.data[i].value = resp.data[i].Description; // Map description
                    }
                    optionsCategorias = resp.data; // Store categories
                    popup = webix.ui({
                        view: 'window', // Create a window for editing
                        id: 'editwinPartnerProducts', // ID for the edit window
                        width: screen.width < 500 ? 500 : 650, // Set width based on screen size
                        height: screen.width < 500 ? 970 : 760, // Set height based on screen size
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen mode for small screens
                        head: {
                            view: 'toolbar', // Toolbar for the window
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Editar Productos Partner'), // Localized label
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the window
                        modal: true, // Modal window
                        body: {
                            view: 'scrollview', // Scrollable body
                            scroll: 'xy', // Enable both axes scrolling
                            body: {
                                view: 'form', // Form for editing product details
                                id: 'editform', // ID for the edit form
                                scroll: true, // Enable scrolling
                                elements: [
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: 'Id', // ID field
                                                name: 'Id',
                                                readonly: true, // Read-only field
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Tiempo Procesamiento'), // Localized label
                                                name: 'ProcessingTime',
                                                labelWidth: 160,
                                                readonly: true, // Read-only field
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Productos'), // Localized label
                                                name: 'Product',
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Proveedor'), // Localized label
                                                name: 'ProviderId',
                                                readonly: true, // Read-only field
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Partner'), // Localized label
                                                name: 'Partner',
                                                readonly: true, // Read-only field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Estado'), // Localized label
                                                name: 'IsActivate',
                                                options: [
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Verificado'), // Localized label
                                                name: 'IsVerified',
                                                options: [
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Filtro País'), // Localized label
                                                name: 'FilterCountry',
                                                options: [
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Mobile'), // Localized label
                                                name: 'Mobile',
                                                options: [
                                                    {
                                                        id: 'S',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'N',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                                readonly: true, // Read-only field
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Escritorio'), // Localized label
                                                name: 'Desktop',
                                                options: [
                                                    {
                                                        id: 'S',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'N',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                                readonly: true, // Read-only field
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Máximo'), // Localized label
                                                name: 'Maximum',
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Mínimo'), // Localized label
                                                name: 'Minimum',
                                                attributes: { type: 'number' }, // Number input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Orden'), // Localized label
                                                name: 'Order',
                                                labelWidth: 160,
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Orden Destacado'), // Localized label
                                                name: 'FeaturedOrder',
                                                labelWidth: 160,
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Comisión'), // Localized label
                                                name: 'Commission',
                                                labelWidth: 160,
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Filas'), // Localized label
                                                name: 'Rows',
                                                labelWidth: 160,
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Columnas'), // Localized label
                                                name: 'Columns',
                                                labelWidth: 160,
                                                attributes: { type: 'number' }, // Number input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Border Destacado'), // Localized label
                                                name: 'BorderColor',
                                                options: [
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('País'), // Localized label
                                                name: 'Country',
                                                options: countries, // Country options from config
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'textarea',
                                                name: 'Info',
                                                label: 'Info', // Info field
                                                labelPosition: 'top',
                                                height: 100,
                                                placeholder: 'Escribe la información aquí...', // Placeholder text
                                            },
                                        ],
                                    },
                                    {
                                        view: 'forminput',
                                        id: 'formCategoriesEdit', // ID for category form input
                                        body: {
                                            view: 'dbllist', // Double list component for categories
                                            id: 'dbllistEdit',
                                            list: { height: 200, scroll: true },
                                            labelLeft: _(
                                                'Categorías sin agregar', // Localized label
                                            ),
                                            labelRight: _(
                                                'Categorías Producto Partner', // Localized label
                                            ),
                                            data: optionsCategorias, // Categories data
                                        },
                                        labelWidth: 140,
                                        labelAlign: 'right',
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'uploader', // Uploader for rectangular image
                                                upload:
                                                    devConfig.geturlApi() +
                                                    'PartnerProduct/UpdatePartnerProductDetails',
                                                id: 'ImageURL', // ID for the uploader
                                                name: 'ImageURL',
                                                value: _('Imagen rectangular'), // Localized label
                                                autosend: false, // Disable auto send
                                                formData: {
                                                    userid: 123, // User ID for form data
                                                    document: 'attachment', // Document type
                                                },
                                            },
                                            {
                                                view: 'uploader', // Uploader for square image
                                                upload:
                                                    devConfig.geturlApi() +
                                                    'PartnerProduct/UpdatePartnerProductDetails2',
                                                id: 'ImageURL2', // ID for the uploader
                                                name: 'ImageURL2',
                                                value: _('Imagen cuadrada'), // Localized label
                                                autosend: false, // Disable auto send
                                                formData: {
                                                    userid: 123, // User ID for form data
                                                    document: 'attachment', // Document type
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Explicación'), // Localized label
                                                name: 'Note',
                                                labelWidth: 160,
                                                attributes: { type: 'text' }, // Text input
                                            },
                                        ],
                                    },
                                    { gravity: 1 }, // Flexible space
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'), // Localized label
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide the window
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form', // Button type
                                                value: _('Guardar'), // Localized label
                                                click: function ($e) {
                                                    if (Object.keys($$('ImageURL').files.data.pull).length > 0) {
                                                        var values = $$('editform').getValues(); // Get form values
                                                        values.Partner = id_partner; // Set partner ID
                                                        $$('ImageURL').config.formData.Id = values.Id; // Set ID for image upload
                                                        $$('ImageURL').config.formData.IsActivate = values.IsActivate; // Set activation status
                                                        $$('ImageURL').config.formData.IsVerified = values.IsVerified; // Set verification status
                                                        $$('ImageURL').config.formData.FilterCountry =
                                                            values.FilterCountry; // Set country filter
                                                        $$('ImageURL').config.formData.Maximum = values.Maximum; // Set maximum value
                                                        $$('ImageURL').config.formData.Minimum = values.Minimum; // Set minimum value
                                                        $$('ImageURL').config.formData.Product = values.Product; // Set product name
                                                        $$('ImageURL').config.formData.Order = values.Order; // Set order
                                                        $$('ImageURL').config.formData.FeaturedOrder =
                                                            values.FeaturedOrder; // Set featured order
                                                        $$('ImageURL').config.formData.Rows = values.Rows; // Set rows
                                                        $$('ImageURL').config.formData.Columns = values.Columns; // Set columns
                                                        $$('ImageURL').config.formData.Note = values.Note; // Set note
                                                        $$('ImageURL').config.formData.BorderColor = values.BorderColor; // Set border color
                                                        $$('ImageURL').config.formData.Partner = values.Partner; // Set partner ID
                                                        $$('ImageURL').config.formData.PartnersWithoutAdd =
                                                            values.PartnersWithoutAdd; // Set partners without add
                                                        $$('ImageURL').config.formData.Country = values.Country; // Set country
                                                        $$('ImageURL').config.formData.Info = values.Info; // Set additional info
                                                        $$('ImageURL').send(function (response) {
                                                            webix.message(
                                                                'Producto Editado', // Success message
                                                            );
                                                        });
                                                        grid.clearAll(); // Clear the grid
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                        this.getTopParentView().hide(); // Hide the window
                                                    } else if (
                                                        Object.keys($$('ImageURL2').files.data.pull).length > 0
                                                    ) {
                                                        var values = $$('editform').getValues(); // Get form values
                                                        values.Partner = id_partner; // Set partner ID
                                                        $$('ImageURL2').config.formData.Id = values.Id; // Set ID for image upload
                                                        $$('ImageURL2').config.formData.IsActivate = values.IsActivate; // Set activation status
                                                        $$('ImageURL2').config.formData.IsVerified = values.IsVerified; // Set verification status
                                                        $$('ImageURL2').config.formData.FilterCountry =
                                                            values.FilterCountry; // Set country filter
                                                        $$('ImageURL2').config.formData.Maximum = values.Maximum; // Set maximum value
                                                        $$('ImageURL2').config.formData.Minimum = values.Minimum; // Set minimum value
                                                        $$('ImageURL').config.formData.Product = values.Product; // Set product name
                                                        $$('ImageURL2').config.formData.Order = values.Order; // Set order
                                                        $$('ImageURL2').config.formData.FeaturedOrder =
                                                            values.FeaturedOrder; // Set featured order
                                                        $$('ImageURL2').config.formData.Rows = values.Rows; // Set rows
                                                        $$('ImageURL2').config.formData.Columns = values.Columns; // Set columns
                                                        $$('ImageURL2').config.formData.Note = values.Note; // Set note
                                                        $$('ImageURL2').config.formData.BorderColor =
                                                            values.BorderColor; // Set border color
                                                        $$('ImageURL2').config.formData.Partner = values.Partner; // Set partner ID
                                                        $$('ImageURL2').config.formData.PartnersWithoutAdd =
                                                            values.PartnersWithoutAdd; // Set partners without add
                                                        $$('ImageURL2').config.formData.Country = values.Country; // Set country
                                                        $$('ImageURL2').config.formData.Info = values.Info; // Set additional info
                                                        $$('ImageURL2').send(function (response) {
                                                            webix.message(
                                                                'Producto Editado', // Success message
                                                            );
                                                        });
                                                        grid.clearAll(); // Clear the grid
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                        this.getTopParentView().hide(); // Hide the window
                                                    } else {
                                                        var values = $$('editform').getValues(); // Get form values
                                                        values.Partner = id_partner; // Set partner ID
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json',
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() +
                                                                    'PartnerProduct/UpdatePartnerProductDetails',
                                                                '{"Id":' +
                                                                    values.Id +
                                                                    ',"IsActivate":"' +
                                                                    values.IsActivate +
                                                                    '","IsVerified":"' +
                                                                    values.IsVerified +
                                                                    '","FilterCountry":"' +
                                                                    values.FilterCountry +
                                                                    '", "Maximum":"' +
                                                                    values.Maximum +
                                                                    '", "Minimum":"' +
                                                                    values.Minimum +
                                                                    '", "Order":"' +
                                                                    values.Order +
                                                                    '", "FeaturedOrder":"' +
                                                                    values.FeaturedOrder +
                                                                    '", "Rows":"' +
                                                                    values.Rows +
                                                                    '", "Columns":"' +
                                                                    values.Columns +
                                                                    '", "Note":"' +
                                                                    values.Note +
                                                                    '", "BorderColor":"' +
                                                                    values.BorderColor +
                                                                    '", "Partner":"' +
                                                                    values.Partner +
                                                                    '", "PartnersWithoutAdd":"' +
                                                                    values.PartnersWithoutAdd +
                                                                    '", "Country":"' +
                                                                    values.Country +
                                                                    '", "Product":"' +
                                                                    values.Product +
                                                                    '", "Commission":"' +
                                                                    values.Commission +
                                                                    '", "Info":"' +
                                                                    values.Info +
                                                                    '"}',
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Error! ', // Show error message
                                                                        );
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            'Producto Partner Editado', // Success message
                                                                        );
                                                                        grid.clearAll(); // Clear the grid
                                                                        grid.load(
                                                                            url +
                                                                                '?start=0&count=' +
                                                                                grid.data.$pagesize +
                                                                                filter, // Reload grid data
                                                                        );
                                                                    },
                                                                },
                                                            );
                                                        this.getTopParentView().hide(); // Hide the window
                                                    }
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                    $$('editform').bind($$('datatable')); // Bind the edit form to the datatable
                    popupAdd = webix.ui({
                        view: 'window', // Create a window for adding products
                        id: 'AddPartnerProducts', // ID for the add window
                        width: screen.width < 500 ? 500 : 600, // Set width based on screen size
                        height: screen.width < 500 ? 680 : 700, // Set height based on screen size
                        fullscreen: screen.width < 500, // Fullscreen mode for small screens
                        head: {
                            view: 'toolbar', // Toolbar for the window
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Añadir Producto Partner'), // Localized label
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the window
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center the window
                        modal: true, // Modal window
                        body: {
                            view: 'scrollview', // Scrollable body
                            scroll: 'xy', // Enable both axes scrolling
                            body: {
                                view: 'form', // Form for adding product details
                                id: 'addform', // ID for the add form
                                scroll: true, // Enable scrolling
                                elements: [
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: 'Productos', // Localized label
                                                name: 'Product',
                                                options: {
                                                    body: {
                                                        dataFeed: function (text) {
                                                            var vthis = this; // Reference to the current instance
                                                            if (text.length > 2) {
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json',
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'es/Select/GamesCasinoSelect',
                                                                        '{"Filter":"' + text + '"}',
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(
                                                                                    'Error! ', // Show error message
                                                                                );
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                var resp = JSON.parse(text);
                                                                                if (!resp.HasError) {
                                                                                    vthis.parse(
                                                                                        resp.Data, // Parse and set data
                                                                                    );
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    },
                                                },
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: 'Partner', // Localized label
                                                name: 'Partner',
                                                options: profile.Partners, // Partner options from profile
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Estado'), // Localized label
                                                name: 'IsActivate',
                                                options: [
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Verificado'), // Localized label
                                                name: 'IsVerified',
                                                options: [
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'combo',
                                                labelPosition: 'top',
                                                label: _('Filtro País'), // Localized label
                                                name: 'FilterCountry',
                                                options: [
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Active option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactive option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _(
                                                    'Tiempo Procesamiento', // Localized label
                                                ),
                                                name: 'ProcessingTime',
                                                labelWidth: 160,
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Máximo'), // Localized label
                                                name: 'Maximum',
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Mínimo'), // Localized label
                                                name: 'Minimum',
                                                attributes: { type: 'number' }, // Number input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Orden'), // Localized label
                                                name: 'Order',
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Orden Destacado'), // Localized label
                                                name: 'FeaturedOrder',
                                                labelWidth: 160,
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Filas'), // Localized label
                                                name: 'Rows',
                                                labelWidth: 160,
                                                attributes: { type: 'number' }, // Number input
                                            },
                                            {
                                                view: 'text',
                                                labelPosition: 'top',
                                                label: _('Columnas'), // Localized label
                                                name: 'Columns',
                                                labelWidth: 160,
                                                attributes: { type: 'number' }, // Number input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10,
                                        cols: [
                                            {
                                                view: 'textarea',
                                                name: 'Info',
                                                label: 'Info', // Info field
                                                labelPosition: 'top',
                                                height: 100,
                                                placeholder: 'Escribe la información aquí...', // Placeholder text
                                            },
                                        ],
                                    },
                                    {
                                        view: 'forminput',
                                        body: {
                                            view: 'dbllist', // Double list component for categories
                                            id: 'dbllistAdd',
                                            list: { height: 200, scroll: true },
                                            labelLeft: _('Categorías'), // Localized label
                                            labelRight: _(
                                                'Categorías Producto Partner', // Localized label
                                            ),
                                            data: optionsCategorias, // Categories data
                                        },
                                        labelWidth: 140,
                                        labelAlign: 'right',
                                    },
                                    {
                                        cols: [
                                            {
                                                view: 'button',
                                                value: _('Cancelar'), // Localized label
                                                click: function () {
                                                    this.getTopParentView().hide(); // Hide the window
                                                    $$('addform').clear(); // Clear the form
                                                },
                                            },
                                            {
                                                view: 'button',
                                                type: 'form', // Button type
                                                value: _('Guardar'), // Localized label
                                                click: function ($e) {
                                                    var values = $$('addform').getValues(); // Get form values
                                                    var c2this = this; // Reference to the current instance
                                                    values.Partner = id_partner; // Set partner ID
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json',
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() +
                                                                'PartnerProduct/CreatePartnerProduct',
                                                            values, // Send form values
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    webix.message(
                                                                        'Error! ', // Show error message
                                                                    );
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    text = JSON.parse(text);
                                                                    if (text.HasError) {
                                                                        webix.message(
                                                                            'Error: ' + text.AlertMessage, // Show error message
                                                                        );
                                                                    } else {
                                                                        $$('addform').clear(); // Clear the form
                                                                        c2this.getTopParentView().hide(); // Hide the window
                                                                        webix.message(
                                                                            'Producto Partner Agregado', // Success message
                                                                        );
                                                                    }
                                                                },
                                                            },
                                                        );
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                },
            });

        // Event listener for adding a product partner
        this.on(this.app, 'addProductPartner:button', (filter) => {
            if (optionsCategorias.length > 0 && products.length > 0) {
                $$('addform').clearValidation(); // Clear validation
                popupAdd.show(); // Show the add window
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });

        // Event listener for filtering partner products
        this.on(this.app, 'partnerProducts:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Get start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Get end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to filter
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Reload grid data with filters
        });

        // Event listener for item click in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load grid data with player ID
            );
        });

        // Event listener for double-click on grid item
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            var item = this.getItem(id); // Get the double-clicked item
            popup.show(); // Show the edit popup
        });

        // Event listener for sorting the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Reload grid data with sorting
            );
        });

        // Fetch products from the API
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Report/GetProducts', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize ID key
                            .replace(/"Name"/g, '"value"'), // Normalize Name key
                    );
                    console.log(data);
                    products = data.Data; // Store product data
                },
            });
    }
}

// FILE DOCUMENTED
